/**
 * @generated SignedSource<<a47bf62523a36dfef3cae0ab33c51b16>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useEditorCollaboratorsFragment_query$data = Result<{
  readonly confluence_contentCollaborators: {
    readonly count: number | null;
    readonly nodes: ReadonlyArray<{
      readonly agent: {
        readonly accountId: string;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      } | null;
      readonly person: {
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly jobTitle?: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
        readonly type: string | null;
      };
    } | null> | null;
  } | null;
  readonly " $fragmentType": "useEditorCollaboratorsFragment_query";
}, unknown>;
export type useEditorCollaboratorsFragment_query$key = {
  readonly " $data"?: useEditorCollaboratorsFragment_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEditorCollaboratorsFragment_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v1 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v2 = {
  "kind": "ScalarField",
  "name": "accountId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useEditorCollaboratorsFragment_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 2147483647
        },
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "contentId"
        }
      ],
      "concreteType": "ConfluenceCollaboratorConnection",
      "kind": "LinkedField",
      "name": "confluence_contentCollaborators",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "concreteType": "ConfluenceCollaborator",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "type"
                },
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "jobTitle"
                    }
                  ],
                  "type": "KnownUser"
                }
              ]
            },
            {
              "concreteType": "ConfluenceAgent",
              "kind": "LinkedField",
              "name": "agent",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v2/*: any*/),
                (v1/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "1c6fdb6138108c5c56d73e9a3340fae9";

export default node;
